module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1532-abb28957fd901ebfe0a665fe8d6ea66b.png";